class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.viewCartButton = this.querySelector('#cart-notification-button');
    if (this.viewCartButton) {
      this.viewCartButton.addEventListener('click', this.handleViewCartClick.bind(this));
    }

    this.querySelectorAll('button[type="button"]').forEach((closeButton) => {
      if (closeButton === this.viewCartButton) return;
      closeButton.addEventListener('click', this.close.bind(this));
    });
  }

  handleViewCartClick(evt) {
    evt.preventDefault();
    this.close();

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return;
    }

    this.openCartDrawer(cartDrawer);
  }

  openCartDrawer(cartDrawer) {
    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    fetch(`${cartUrl}?sections=cart-drawer,cart-icon-bubble`)
      .then((response) => {
        if (!response.ok) throw new Error(`Section fetch failed with status ${response.status}`);
        return response.json();
      })
      .then((sections) => cartDrawer.renderContents({ sections }))
      .catch((error) => {
        console.error('cart-notification: failed to refresh cart drawer contents', error);
        cartDrawer.open();
      });
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
